import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Hint, InlineCode } from '@nejcm/docz-theme-extended';
import searchPic from '../../public/assets/search.jpg';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "search"
    }}>{`Search`}</h1>
    <p>{`Search allows users to search documents by name or tags. The search button is displayed inside the header bar.`}</p>
    <img src={searchPic} alt="Search" />
    <h2 {...{
      "id": "config"
    }}>{`Config`}</h2>
    <h3 {...{
      "id": "search-1"
    }}>{`Search`}</h3>
    <p>{`Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`themeConfig.search`}</inlineCode>{` option to enable or disable search.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    search: true,
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`search`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify if the search should be shown.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "tags"
    }}>{`Tags`}</h3>
    <p>{`Tags are additional information inside each document that are searchable. They can be separated with commas.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-mdx"
      }}>{`---
name: Footer
route: /ui/footer
menu: UI
tags: ui, footer, footer config, theme, user interface
---

# My mdx file
`}</code></pre>
    <h4 {...{
      "id": "options-1"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`tags`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Tags separated by commas or spaces.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      